import React, { Component } from 'react'
import { graphql } from 'gatsby'
import {
  Container,
  Column,
  Columns,
  Content,
  Hero,
  HeroBody,
  Subtitle,
  Tabs,
  Tab,
  TabList,
  TabLink,
  Title
} from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../../components/breadcrumbs'
import FontAwesome from '../../components/fontawesome'
import Head from '../../components/head'
import Image from '../../components/image'
import Layout from '../../components/layout'
import Link from '../../components/link'
import PressItems from '../../components/press'

import events from '../../content/resources/news/events'

const ShortHeroBody = styled(HeroBody)`
  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const Event = styled.div`
  align-items: center;
  background-color: #141414;
  border-radius: 4px;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.55);

  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  height: 420px;
  padding: 1rem;

  .subtitle,
  .content {
    color: white !important;
  }
`

const RoundImage = styled(Image)`
  border-radius: 50%;
  margin: 0 auto;
  max-height: 480px;
  max-width: 75%;
`

const TabItem = styled.span`
  font-size: 1.25rem;

  :active,
  :focus,
  :hover {
    color: rgba(31, 190, 218, 1);
  }
`

const newsTabs = ['About', 'News', 'Events']

class News extends Component {
  state = {
    activeTab: 0
  }

  renderEvents = () =>
    events.map(({ name, booth, description, days, location, url }) => (
      <Column key={url} isSize={{ default: 4, mobile: 'full' }}>
        <Event>
          <Subtitle isSize={4}>{name}</Subtitle>
          <Content isSize={'small'}>{description}</Content>
          <Content isSize={'medium'}>
            <div>{days}</div>
            <div>{location}</div>
            <div>Booth: {booth}</div>
          </Content>
          <Link
            className={'learn-more-link'}
            rel={`noopener`}
            style={{ fontSize: '1.25rem', marginBottom: '8px' }}
            target={`_blank`}
            to={url}
          >
            Learn More
            <FontAwesome
              alt={`learn more about Route`}
              aria-label={`learn more about Route`}
              className={'learn-more-icon'}
              icon={['fa', 'arrow-alt-circle-right']}
              style={{ fontSize: '1.25rem', marginLeft: '0.5rem' }}
            />
          </Link>
        </Event>
      </Column>
    ))

  renderPressReleases = () =>
    this.props.data.allMarkdownRemark.edges.map(({ node }) => (
      <li key={node.id}>
        <Link to={`/${node.fields.slug}`}>{node.frontmatter.title}</Link>
      </li>
    ))

  renderTabs = () =>
    newsTabs.map((tab, index) => (
      <Tab key={tab} isActive={this.state.activeTab === index}>
        <TabLink href={`#${tab.toLowerCase()}`} onClick={() => this.setActiveTab(index)}>
          <TabItem>{tab}</TabItem>
        </TabLink>
      </Tab>
    ))

  setActiveTab = activeTab => this.setState({ activeTab })

  render() {
    return (
      <Layout>
        <Head
          author={'Route'}
          title={'News and Press'}
          description={'News, press and public relations coverage for Route: The Service Platform.'}
          keywords={[
            'route',
            'route the service platform',
            'business management software',
            'software for service companies',
            'resources',
            'events',
            'news',
            'press'
          ]}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        <Hero isColor={'light'} isSize={'medium'}>
          <ShortHeroBody>
            <Container hasTextAlign={'centered'}>
              <Title isSize={1} className={`huge`}>
                Route Newsroom
              </Title>
              <Subtitle isSize={3} style={{ marginBottom: '4rem' }}>
                News, Events, Press Coverage: Everything you need to know about Route.
              </Subtitle>
            </Container>
          </ShortHeroBody>
        </Hero>
        <Hero
          isColor={`dark`}
          isSize={'small'}
          style={{
            boxShadow: '0 3px 4px rgba(0, 0, 0, 0.55)'
          }}
        >
          <HeroBody>
            <Container>
              <Tabs isSize={`medium`}>
                <TabList style={{ borderBottom: 'none' }}>{this.renderTabs()}</TabList>
              </Tabs>
            </Container>
          </HeroBody>
        </Hero>
        <Hero id={`about`} isColor={'black'} isSize={'medium'}>
          <HeroBody>
            <Container>
              <Columns isCentered isVCentered>
                <Column>
                  <Subtitle isSize={2}>About Route</Subtitle>
                  <Content isSize={`medium`}>
                    Route was developed for the unique and complex needs of Building Service Contractors, featuring
                    mobile and web applications for managing the full Account Lifecycle while creating synergies across
                    the day to day activities happening at your company. Walkthrough Builder&#8482; collects and
                    organizes the scope of work including dimensions, floor type, hot points and special notes by room,
                    area, or task on site with actual images of the prospect's space. Use this information to calculate
                    your Bid with Route's Estimator, then generate a Proposal supercharged by custom templates,
                    personalization, and automation that bring you and your team unprecedented growth and productivity.
                  </Content>
                  <Link className={'learn-more-link'} style={{ fontSize: '1.25rem' }} to={`/about`}>
                    Learn More
                    <FontAwesome
                      alt={`learn more about Route`}
                      aria-label={`learn more about Route`}
                      className={'learn-more-icon'}
                      icon={['fa', 'arrow-alt-circle-right']}
                      style={{ fontSize: '1.25rem', marginLeft: '0.5rem' }}
                    />
                  </Link>
                </Column>
                <Column>
                  <RoundImage file={this.props.data.armandobello} />
                </Column>
              </Columns>
            </Container>
          </HeroBody>
        </Hero>
        <Hero id={`news`} isColor={'light'} isSize={'small'}>
          <HeroBody>
            <Container hasTextAlign={'centered'} style={{ padding: '2rem 0' }}>
              <Subtitle isSize={1}>Route In The News</Subtitle>
              <PressItems />
            </Container>
          </HeroBody>
        </Hero>
        <Hero id={`press`} isColor={'light'} isSize={'small'}>
          <HeroBody>
            <Container hasTextAlign={'centered'} style={{ margin: '0 auto 2rem auto', padding: '2rem 0' }}>
              <Subtitle isSize={1} style={{ marginBottom: '4rem' }}>
                Press Releases
              </Subtitle>
              <Columns isCentered isGrid isMultiline>
                <ul>{this.renderPressReleases()}</ul>
              </Columns>
            </Container>
          </HeroBody>
        </Hero>
        <Hero id={`events`} isColor={'light'} isSize={'small'}>
          <HeroBody>
            <Container hasTextAlign={'centered'} style={{ margin: '0 auto 2rem auto', padding: '2rem 0' }}>
              <Subtitle isSize={1} style={{ marginBottom: '4rem' }}>
                Route At Events
              </Subtitle>
              <Columns isCentered isGrid isMultiline>
                {this.renderEvents()}
              </Columns>
            </Container>
          </HeroBody>
        </Hero>
      </Layout>
    )
  }
}

export const query = graphql`
  query NewsQuery {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { draft: { ne: true }, type: { eq: "Press Release" } } }
    ) {
      edges {
        node {
          id
          html
          excerpt
          timeToRead
          frontmatter {
            title
            date
            draft
            type
          }
          fields {
            slug
          }
        }
      }
    }
    armandobello: file(relativePath: { eq: "assets/team/armando-bello.jpg" }) {
      ...FluidImage
    }
  }
`

export default News
